const EventDateManagement = () => import("./views/EventDateManagement.vue");
const EventDateExamMarks = () => import("./views/EventDateExamMarks.vue");
const EventTranslations = () => import("./views/EventTranslations.vue");

export const eventAdminRoutes = [
  {
    path: "/admin/event",
    name: "AdminEvent",
    component: EventDateManagement,
  },
  {
    path: "/admin/event/exam",
    props: true,
    name: "AdminEventExam",
    component: EventDateExamMarks,
  },
  {
    path: "/event-translations/:eventId/",
    name: "EventTranslations",
    component: EventTranslations,
    props: true,
  },
];
